/*
 * 505 — mix & match sold-out state on collection pages.
 *
 * Why this exists: a collection page cannot resolve a set's components. Liquid's
 * all_products object is capped at 20 unique handles per page and past that it
 * returns empty or hands back the previously resolved product, so judging sets in
 * the card template showed buyable sets as sold out (505) and hid real sold-outs
 * (497). A product's own page has its own budget, so we ask it:
 *
 *   /products/<handle>?view=oos  ->  templates/product.oos.liquid
 *                                ->  snippets/mix-match-sold-out.liquid
 *
 * That keeps exactly one implementation of the sold-out rule, shared with the PDP.
 *
 * snippets/product-grid-item-CP.liquid marks each set card with data-mm-check="true"
 * and carries the badge's label and colours as data attributes, so this file holds no
 * theme values of its own.
 *
 * Every marked card is checked on load — no caching, no lazy loading, so the state is
 * always current for the page being rendered.
 *
 * The badge is built here rather than pre-rendered hidden, for two reasons:
 *   - .badges-wrapper has display:flex in custom-styles.css, which overrides the
 *     browser's [hidden] rule, so a hidden badge is not hidden;
 *   - atc_popup_cp.js skips any card containing .grid-product__tag--sold-out, so a
 *     pre-rendered badge would stop the quick-ATC popup from ever being added.
 * Once the badge does exist, that same check makes its later passes skip the card,
 * which is why we insert the badge before removing any buttons.
 *
 * Fails open: on any error the card stays exactly as rendered (buyable).
 */
(function () {
  if (window.__mmOosCp) return;
  window.__mmOosCp = true;

  var CARD = '[data-mm-check="true"]';
  var MAX_BYTES = 2000;

  function styleTag(card, tag) {
    tag.style.backgroundColor = card.getAttribute('data-mm-soldout-bg') || '';
    tag.style.color = card.getAttribute('data-mm-soldout-color') || '';
    tag.textContent = card.getAttribute('data-mm-soldout-label') || '';
  }

  // Grid layouts (collection, featured, recommendations): an absolutely positioned
  // .badges-wrapper over the image, matching snippets/product-badges.liquid.
  function buildGridBadge(card) {
    var wrapper = document.createElement('div');
    wrapper.className = 'badges-wrapper round_badges_test';
    wrapper.id = 'product_badge_js_' + (card.getAttribute('data-product-id') || '');
    wrapper.setAttribute('data-mm-soldout-badge', '');

    var tag = document.createElement('div');
    tag.className = 'grid-product__tag grid-product__tag--sold-out';
    styleTag(card, tag);

    wrapper.appendChild(tag);
    return wrapper;
  }

  // Search results use different markup and a different position: no wrapper, in the
  // text flow above the title. See the template == 'search' branch in
  // snippets/product-grid-item.liquid, which this mirrors exactly.
  function buildSearchBadge(card) {
    var tag = document.createElement('div');
    tag.className = 'grid-product__tag--search grid-product__tag grid-product__tag--sold-out round_badges_test';
    tag.style.fontSize = '14px';
    tag.setAttribute('data-mm-soldout-badge', '');
    styleTag(card, tag);
    return tag;
  }

  function insertBadge(card) {
    if (card.getAttribute('data-mm-badge') === 'search') {
      var meta = card.querySelector('.grid-product__meta');
      if (!meta) return;
      // coming_soon takes precedence over sold out in the template too.
      if (meta.querySelector('[data-mm-soldout-badge], .grid-product__tag--coming-soon')) return;
      meta.insertBefore(buildSearchBadge(card), meta.firstChild);
      return;
    }

    var content = card.querySelector('.grid-product__content');
    if (!content) return;
    // A custom label takes precedence over every badge in product-badges.liquid, so
    // mirror that and add nothing when one is present.
    if (content.querySelector('.grid-product__tag--custom') || content.querySelector('[data-mm-soldout-badge]')) return;
    // Sold out replaces the save / tag badges, same as product-badges.liquid does.
    var existing = content.querySelectorAll('.badges-wrapper');
    for (var b = 0; b < existing.length; b++) existing[b].remove();
    content.insertBefore(buildGridBadge(card), content.firstChild);
  }

  function apply(card, soldOut) {
    card.setAttribute('data-mm-checked', soldOut ? 'sold-out' : 'available');
    if (!soldOut) return;

    // Insert the badge first: atc_popup_cp.js skips cards containing
    // .grid-product__tag--sold-out, so a later pass of its retryPool leaves this card
    // alone instead of re-adding the button we remove below.
    insertBadge(card);

    // Then drop whatever buy path was already rendered or injected.
    var buttons = card.querySelectorAll('.custom_quick_cp, .grid-product__meta-btn .add-to-cart');
    for (var i = 0; i < buttons.length; i++) buttons[i].remove();

    var link = card.querySelector('.grid-product__link');
    if (link) link.classList.add('grid-product__link--disabled');
  }

  function check(card) {
    var handle = card.getAttribute('data-product-handle');
    if (!handle) return;

    fetch('/products/' + encodeURIComponent(handle) + '?view=oos', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('status ' + res.status);
        return res.text();
      })
      .then(function (text) {
        // A missing product.oos template makes Shopify serve the whole product page
        // with a 200, so validate the shape rather than trusting the status.
        if (text.length > MAX_BYTES) throw new Error('not the oos view');
        var data = JSON.parse(text);
        if (data.ok !== true) throw new Error('unexpected payload');
        apply(card, data.sold_out === true);
      })
      .catch(function () {
        /* fail open — leave the card buyable, as rendered */
      });
  }

  function scan() {
    var cards = document.querySelectorAll(CARD);
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.hasAttribute('data-mm-queued')) continue;
      card.setAttribute('data-mm-queued', '');
      check(card);
    }
  }

  function init() {
    scan();
    // The grid is re-rendered on filter / sort / pagination, which replaces the cards.
    var grid = document.querySelector('#CollectionAjaxContent') || document.body;
    new MutationObserver(function () { scan(); }).observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
